import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { authwsEnvironment } from './authws-environment';
import { licensedAppsSchema } from './schemas/licensed-app.schema';

export function getProducts() {
  return fromFetch(
    new Request(authwsEnvironment.productsUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(licensedAppsSchema));
}
